import React from 'react';
import styled, { keyframes } from 'styled-components';

const floatAnimation = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-50px);
    opacity: 0.7;
  }
  100% {
    transform: translateY(-100px);
    opacity: 0;
  }
`;

const Particle = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.1);
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  animation: ${floatAnimation} 5s infinite linear;
`;

const ParticlesContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; 
  z-index: -1;
`;

const generateParticles = () => {
  const particles = [];
  for (let i = 0; i < 100; i++) {
    const size = Math.floor(Math.random() * 7) + 1; // Random size between 1 and 7
    particles.push(<Particle key={i} size={size} style={{ left: `${Math.random() * 100}vw`, top: `${Math.random() * 100}vh` }} />);
  }
  return particles;
};

const FloatingParticles = () => {
  return (
    <ParticlesContainer>
      {generateParticles()}
    </ParticlesContainer>
  );
};

export default FloatingParticles;
